import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { useHistory, useLocation } from "react-router-dom";
import { fontFamily, useSharedValue } from "../Constants/constants";
import OrganizationChartManager from "../../tree_views/horizontal_view";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import SecureDocumentViewer from "../WorkLoade_File_Import/SecureDocumentViewer";
import PdfViewerIcon from "../../assets/new icons/extraction review/SVG (1).svg";
import ExtractedDataIcon from "../../assets/new icons/extraction review/SVG (2).svg";
import VisualisationIcon from "../../assets/new icons/extraction review/SVG (3).svg";

export default function DisplayExtractionView() {
  const { handleTreeView, isMenuOpen } = useSharedValue();
  const location = useLocation();
  const row = location.state?.row;
  const someValue = location.state?.someValue;
  const rooValue = location.state?.rootValue;
  const dataExtraction = JSON.parse(location.state?.datatable || "[]") ?? [];
  const dataTree = JSON.parse(location.state?.dataTree || "[]") ?? [];

  const [treeData, setTreeData] = useState([]);
  const [extractionRows, setextractionRows] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [leftActiveTab, setLeftActiveTab] = useState("pdfViewer");
  const [rightActiveTab, setRightActiveTab] = useState("extractedData");

  const history = useHistory();

  // Build a code→name map from extraction rows and enrich tree nodes
  const enrichTreeNode = (node, nameMap, reverseMap) => {
    if (!node) return node;
    const code = node.name || "";
    const actualName = nameMap[code] || nameMap[code.trim()] || "";
    // When the tree node already carries the display name (not a UID),
    // use the reverse map to resolve the UID for the badge.
    const uid = actualName ? code : reverseMap[code] || reverseMap[code.trim()] || "";
    return {
      ...node,
      name: actualName || code,
      attributes: {
        ...(node.attributes || {}),
        number: uid || code,
      },
      children: (node.children || []).map((child) => enrichTreeNode(child, nameMap, reverseMap)),
    };
  };

  useEffect(() => {
    if (someValue != null && someValue !== "") {
      const rows = dataExtraction.length > 0 ? dataExtraction : [];
      // Forward map: UID/code → display name
      const nameMap = {};
      // Reverse map: display name → UID/code
      const reverseMap = {};
      rows.forEach((r) => {
        const code = r["Number"] || r["number"] || r["code"] || "";
        const name = r["Name"] || r["name"] || "";
        if (code && name) {
          nameMap[code] = name;
          reverseMap[name] = code;
        }
      });
      const enriched = (Array.isArray(dataTree) ? dataTree : [dataTree]).map((n) =>
        enrichTreeNode(n, nameMap, reverseMap)
      );
      setTreeData(enriched);
      if (rows.length > 0) {
        setextractionRows(rows);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [someValue]);

  const _handleSaveClickChanges = (fileImportId, filename) => {
    setIsLoading(true);

    const baseRow = rows.find((item) => item.fileImportId === fileImportId) || {};
    const updatedRowData = {
      ...baseRow,
      dataExtraction: JSON.stringify(extractionRows),
    };

    const formData = new FormData();
    formData.append("filename", filename);
    formData.append("validateData", updatedRowData.dataExtraction);
    formData.append("parentName", treeData[0]?.name || "");

    fetch("https://whsai.complytaxforms.com/saveEditedTableData", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        setIsLoading(false);
        if (response.ok) {
          response.json().then((data) => {
            const updated = {
              ...baseRow,
              dataVisualisation: JSON.stringify(data.treeData),
              dataExtraction: JSON.stringify(extractionRows),
              dataValidation: JSON.stringify(data.extractedValidationData),
            };
            setRows((prev) =>
              prev.map((r) => (r.fileImportId === updated.fileImportId ? updated : r))
            );
            setTreeData(data.treeData);
            fetch("https://euswhsbe.azurewebsites.net/FileData/ImportFiles", {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
              },
              body: JSON.stringify(updated),
            }).then((res) => {
              if (res) {
                history.push(rooValue);
                setIsLoading(false);
              }
            });
          });
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Fetch error:", error);
      });
  };

  const _handleUpdateView = (event) => {
    handleTreeView(event.target.value);
  };

  // ── Styles ──────────────────────────────────────────────────────────────────

  const tabIconStyle = (isActive) => ({
    width: 16,
    height: 16,
    filter: isActive ? "var(--dev-tab-active-icon-filter)" : "none",
  });

  const tabStyle = (isActive) => ({
    padding: "10px 14px",
    fontSize: 13,
    fontFamily: fontFamily,
    fontWeight: isActive ? 500 : 400,
    color: isActive ? "var(--dev-tab-active-color)" : "#667085",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 6,
    background: "transparent",
    border: "none",
    borderBottom: isActive ? "2px solid var(--dev-tab-active-color)" : "2px solid transparent",
    whiteSpace: "nowrap",
  });

  const badgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--badge-bg)",
    color: "var(--dev-num-badge-text)",
    borderRadius: "50%",
    width: 22,
    height: 22,
    minWidth: 22,
    minHeight: 22,
    fontSize: 11,
    fontWeight: 600,
    lineHeight: 1,
    flexShrink: 0,
  };

  // ── Sub-components ───────────────────────────────────────────────────────────

  const LoadingOverlay = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        backgroundColor: "rgba(255,255,255,0.5)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      >
        <CircularProgress style={{ color: "var(--loader-color)" }} />
      </div>
    </div>
  );

  const ExtractionCards = () => (
    <div>
      {extractionRows.map((dataRow, idx) => {
        const entityType = dataRow["Entity Type"] || "";
        const chapter4 = dataRow["Chapter4Status"] || "";
        const number = dataRow["Number"] || "";
        const giin = dataRow["GIIN"] || "";
        const ftin = dataRow["ForeignTaxpayerId"] || dataRow["FTIN"] || "";
        const ein = dataRow["EIN"] || "";
        const ssnOrItin = dataRow["SSNOrITIN"] || "";
        const permCountry = dataRow["Perm. Country"] || dataRow["Permanent Country"] || "";
        const permAddress =
          dataRow["Perm. Address Line1"] || dataRow["Permanent Address Line 1"] || "";
        const allocation = dataRow["Allocation"] || "";

        return (
          <div
            key={idx}
            style={{
              background: "var(--dev-card-bg)",
              border: "1px solid var(--dev-card-border)",
              borderRadius: 8,
              marginBottom: 12,
              overflow: "hidden",
            }}
          >
            {/* Card header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 16px",
                gap: 12,
              }}
            >
              <div
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: "7.48px",
                  backgroundColor: "var(--badge-bg)",
                  color: "var(--dev-num-badge-text)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 13,
                  fontWeight: 600,
                  fontFamily: fontFamily,
                  flexShrink: 0,
                }}
              >
                {idx + 1}
              </div>
              <div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: 14,
                    fontFamily: fontFamily,
                    color: "#1a1a1a",
                  }}
                >
                  {dataRow["Name"] || "—"}
                </div>
                <div
                  style={{
                    fontSize: 12,
                    color: "#667085",
                    fontFamily: fontFamily,
                  }}
                >
                  {entityType}
                  {number ? ` · ${number}` : ""}
                </div>
              </div>
            </div>

            {/* Fields grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "8px 16px",
                padding: "0 16px 14px",
              }}
            >
              {[
                { label: "CHAPTER 4 STATUS", value: chapter4 },
                { label: "EIN", value: ein || "—" },
                { label: "SSN OR ITIN", value: ssnOrItin || "—" },
                { label: "GIIN", value: giin || "—" },
                { label: "FTIN", value: ftin || "—" },
                { label: "PERMANENT COUNTRY", value: permCountry || "—" },
                { label: "PERMANENT ADDRESS LINE 1", value: permAddress || "—" },
                { label: "ALLOCATION", value: allocation || "—" },
              ].map(({ label, value }) => (
                <div key={label}>
                  <div
                    style={{
                      fontSize: 10,
                      color: "#9e9e9e",
                      fontFamily: fontFamily,
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      marginBottom: 2,
                    }}
                  >
                    {label}
                  </div>
                  <div
                    style={{
                      fontSize: 12,
                      color: "#1a1a1a",
                      fontFamily: fontFamily,
                    }}
                  >
                    {value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );

  const VisualisationPanel = () => (
    <div
      style={{
        width: "100%",
        height: "100%",
        padding: 10,
      }}
    >
      {treeData.length > 0 && <OrganizationChartManager data={treeData} />}
    </div>
  );

  const PdfPanel = () => (
    <SecureDocumentViewer
      organizationId={row?.organizationId}
      userId={row?.userID}
      fileImportId={row?.fileImportId}
      fileName={row?.fileName}
      fileType="uploadfiles"
      useFastLoad
    />
  );

  // ── Render ───────────────────────────────────────────────────────────────────

  return (
    <div
      id="extraction_Review"
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 10,
        marginLeft: 20,
        marginTop: 20,
        width: isMenuOpen === true ? "calc(100vw - 280px)" : "calc(100vw - 128px)",
        marginRight: 20,
        height: "calc(100vh - 92px)",
      }}
    >
      {isLoading && <LoadingOverlay />}

      {/* ───── LEFT PANEL ───── */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          background: "white",
          borderRadius: 8,
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        {/* Tab bar */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: 12,
            paddingRight: 12,
            gap: 4,
            flexShrink: 0,
          }}
        >
          <button
            style={tabStyle(leftActiveTab === "pdfViewer")}
            onClick={() => setLeftActiveTab("pdfViewer")}
          >
            <img src={PdfViewerIcon} alt="" style={tabIconStyle(leftActiveTab === "pdfViewer")} />
            PDF Viewer
          </button>
          <button
            style={tabStyle(leftActiveTab === "extractedData")}
            onClick={() => setLeftActiveTab("extractedData")}
          >
            <img
              src={ExtractedDataIcon}
              alt=""
              style={tabIconStyle(leftActiveTab === "extractedData")}
            />
            Extracted Data <span style={badgeStyle}>{extractionRows.length}</span>
          </button>
          <button
            style={tabStyle(leftActiveTab === "visualisation")}
            onClick={() => setLeftActiveTab("visualisation")}
          >
            <img
              src={VisualisationIcon}
              alt=""
              style={tabIconStyle(leftActiveTab === "visualisation")}
            />
            Visualization
          </button>
        </div>

        {/* Content */}
        <div
          style={{
            flex: 1,
            overflow: "auto",
            padding: leftActiveTab === "visualisation" ? 0 : 16,
          }}
        >
          {leftActiveTab === "pdfViewer" && <PdfPanel />}
          {leftActiveTab === "extractedData" && <ExtractionCards />}
          {leftActiveTab === "visualisation" && <VisualisationPanel />}
        </div>
      </div>

      {/* ───── RIGHT PANEL ───── */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          background: "white",
          borderRadius: 8,
          overflow: "hidden",
          minWidth: 0,
        }}
      >
        {/* Tab bar + Return */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: 12,
            paddingRight: 12,
            gap: 4,
            flexShrink: 0,
          }}
        >
          <button
            style={tabStyle(rightActiveTab === "pdfViewer")}
            onClick={() => setRightActiveTab("pdfViewer")}
          >
            <img src={PdfViewerIcon} alt="" style={tabIconStyle(rightActiveTab === "pdfViewer")} />
            PDF Viewer
          </button>
          <button
            style={tabStyle(rightActiveTab === "extractedData")}
            onClick={() => setRightActiveTab("extractedData")}
          >
            <img
              src={ExtractedDataIcon}
              alt=""
              style={tabIconStyle(rightActiveTab === "extractedData")}
            />
            Extracted Data <span style={badgeStyle}>{extractionRows.length}</span>
          </button>
          <button
            style={tabStyle(rightActiveTab === "visualisation")}
            onClick={() => setRightActiveTab("visualisation")}
          >
            <img
              src={VisualisationIcon}
              alt=""
              style={tabIconStyle(rightActiveTab === "visualisation")}
            />
            Visualization
          </button>
          <div style={{ marginLeft: "auto" }}>
            <Button
              variant="contained"
              className="review-btn-outline"
              onClick={() => history.push(rooValue)}
            >
              Return
            </Button>
          </div>
        </div>

        {/* Content */}
        <div
          style={{
            flex: 1,
            overflow: "auto",
            padding: rightActiveTab === "visualisation" ? 0 : 16,
          }}
        >
          {rightActiveTab === "pdfViewer" && <PdfPanel />}
          {rightActiveTab === "extractedData" && <ExtractionCards />}
          {rightActiveTab === "visualisation" && <VisualisationPanel />}
        </div>
      </div>
    </div>
  );
}
